import { generateApiPath } from '@scouts/helpers'

import { AccountantDTO } from '@/models'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAccountant: builder.query<AccountantDTO, { id?: number }>({
            query: ({ id }) => ({
                method: 'GET',
                url: generateApiPath(ENDPOINTS.ACCOUNTANT.GET, { id }),
            }),
        }),
    }),
})

export const { useGetAccountantQuery } = extendedApi
